module.exports = __webpack_public_path__ + "img/bottom_bg2.f0c1f281.png";